export enum IntegrationCategories {
  blockchain = 'Blockchain',
  exchange = 'Exchange',
  wallet = 'Wallet',
}

export enum IntegrationSyncMethod {
  AutoSync = 'Automatic sync',
  CustomFile = 'Custom file',
  CoinTrackerCSV = 'CoinTracker CSV',
  AutoSyncAndFile = 'Automatic sync & custom file',
}

export interface IntegrationInfo {
  hideInstructions?: boolean;
}

export interface Integration {
  slug?: string;
  name?: string;
  imageUrl?: string;
  syncMethod?: IntegrationSyncMethod;
  isDisabled?: boolean;
  category?: IntegrationCategories;
  rank: number;
  instructions?: string;
  info?: IntegrationInfo;
  description?: string;
  supportsHdWallet?: boolean;
}

export const getLinkForExchangeAndWallet = (
  slug: string,
  isAuthenticated?: boolean,
  isExchange?: boolean,
) => {
  if (!isAuthenticated) {
    return `${isExchange ? 'exchanges' : 'wallet-integrations'}/${slug.toLowerCase()}`;
  }
  return `/wallets?add_integration=${slug.toLowerCase()}_${
    isExchange ? 'exchange' : 'wallet'
  }`;
};

export const getLinkForBlockchain = (
  slug: string,
  isAuthenticated?: boolean,
) => {
  if (!isAuthenticated) {
    return `/blockchains/${slug.toLowerCase()}`;
  }
  return `/wallets?add_integration=${slug.toLowerCase()}_blockchain`;
};

interface getLinkForCardProps {
  slug?: string;
  category?: IntegrationCategories;
  isAuthenticated?: boolean;
}
export const getLinkForCard = ({
  slug,
  category,
  isAuthenticated,
}: getLinkForCardProps) => {
  if (!slug) {
    return '#';
  }
  if (
    category === IntegrationCategories.exchange ||
    category === IntegrationCategories.wallet
  ) {
    return getLinkForExchangeAndWallet(
      slug,
      isAuthenticated,
      category === IntegrationCategories.exchange,
    );
  }
  if (category === IntegrationCategories.blockchain) {
    return getLinkForBlockchain(slug, isAuthenticated);
  }
  return '#';
};
